// eslint-disable-next-line @typescript-eslint/naming-convention
import VueDOMPurifyHTML from 'vue-dompurify-html'

export default defineNuxtPlugin({
  parallel: true,
  setup(nuxtApp) {
    nuxtApp.vueApp.use(VueDOMPurifyHTML)
  }
})
